import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { ref } from '@dbk-legacy/muster/utils';
import { createContainer } from '@dbk-legacy/muster/react';
import { FormattedMessage } from '@dbk-legacy/format';

import map from 'lodash/fp/map';
import format from 'date-fns/format';

import ScrollableLayout from '../../../../../src/components/common/scrollable-layout';
import { LoadingCircle } from '../../../../../src/components/common/loading';
import SortingHeader from '../../../../../src/components/common/sorting-header';
import ListView from '../../../../../src/components/common/list-view';
import { XSmall, Large } from '../../../../../src/components/common/text';
import FullMonthYear from '../../../../../src/components/common/fullMonth-Year';

import Header from '../../../../../src/screens/maturities/header';
import RowAssetItem from '../../../../../src/screens/maturities/row-asset-item';
import EmptyState from '../../../../../src/screens/maturities/empty-state';

import Error from '../../../../../src/components/common/error';
import { View } from 'react-native';
import styles from '../../../../../src/screens/maturities/maturities.styles.js';

const GROUP_DATE_FORMAT = 'MMMM YYYY';

class Maturities extends PureComponent {

  formatDateLabel(date) {
    if (typeof date === 'string') {
      date = Date.parse(date);
      const monthYear = format(date, GROUP_DATE_FORMAT);
      return <FullMonthYear value={'11' + monthYear} />
    }
  }

  componentDidMount(){
    if(document.querySelector('.logo-web')){
      document.querySelector('.logo-web').focus();
    }
  }

  renderAssets(maturities, columns, changePage, resetDetailSort, messages) {
    const {
      assetsSorted,
      setDetailTitle,
      setDetailMarketValue,
      setDetailAssets,
    } = maturities;

    const pushAsset = map(item => ({
      header: item.hasGrouping && !!item.groupLabel &&
        <ListView.RowGroupHeader text={<Large>{this.formatDateLabel(item.groupLabel)}</Large>} />,
      rows: [
        <RowAssetItem
          asset={item}
          columns={columns}
          setDetailTitle={setDetailTitle}
          setDetailMarketValue={setDetailMarketValue}
          setDetailAssets={setDetailAssets}
          changePage={changePage}
          resetDetailSort={resetDetailSort}
          messages={messages} />,
        assetsSorted.indexOf(item) < assetsSorted.length - 1 &&
        <ListView.RowSeparator fullWidth={item.hasGrouping && (!item.groupLabel || item.groupEnding)} />,
      ],
    }));

    return pushAsset(assetsSorted);
  }

  renderDisclaimer() {
    return {
      header: null,
      rows: [
        <XSmall style={{ padding: 10 }} type="secondary">
          <FormattedMessage id="app.maturities.overview.ch.disclaimer" />
        </XSmall>
      ],
    };
  }

  render() {
    const {
      maturities,
      portfolio,
      ui,
      changePage,
      i18n: { messages },
    } = this.props;

    const uiState = ui.state.maturities;
    const uiStateDetail = ui.state.maturitiesAssets;
    const columns = ui.static.maturities.options;
    const emptyState = maturities.selectedTab.periodType !== 'custom' &&
      <EmptyState maturities={maturities} />;
    const isEmpty = maturities.assetsSorted == null || maturities.assetsSorted.length == 0;
    const hasGrouping = !isEmpty && maturities.assetsSorted[0].hasGrouping;
    const body = isEmpty ? emptyState :
      this.renderAssets(maturities, columns, changePage, uiStateDetail.resetDetailSort, messages);
    const dateRangeFn = {
      showDateRange: maturities.showDateRange,
      setShowDateRange: maturities.setShowDateRange
    }
    // .concat(this.renderDisclaimer());


    // enabled={!hasGrouping}
    return (
      <div className="row">
        <div className="small-12 small-centered medium-12 medium-centered large-12 large-centered">
          <ScrollableLayout
            testID="maturities-overview"
            header={<Header maturities={maturities} isEmpty={isEmpty} resetSort={uiState.resetSort} messages={messages} dateRangeFn={dateRangeFn} />}
            stickyHeader={
              !isEmpty &&
              <div className="edelStickyHeader">
                <SortingHeader
                  currency={portfolio.referenceCurrency}
                  options={columns}
                  showBorder={hasGrouping}
                  state={uiState}
                  messages={messages}
                /></div>
            }
            body={isEmpty ? <div className="edelBodyIsEmpty" id="text_maturities_maturityHome_test">{emptyState}</div> :
              <div className="edelBodyIsList"> {body.map((item) => (
                <div>{item.header}{item.rows}</div>))}
              </div>}
          />
        </div>
      </div>
    );
  }
}

export default createContainer({
  $renderError: () => <Error />,
  $renderLoading: () => <LoadingCircle isPage />,
  $queries: {
    app: {
      global: {
        deviceInfo: {
          isTablet: true
        }
      }
    },
    i18n: {
      messages: true,
    },
    changePage: { $call: 'ui.history.push' },
    portfolio: {
      referenceCurrency: true,
    },
    maturities: {
      ...Header.getFragment('maturities'),
      ...EmptyState.getFragment('maturities'),
      assetsSorted: {
        $type: 'list',
        $range: {
          offset: 0,
          length: ref('maturities.assets.length'),
        },
        $node: {
          id: true,
          name: true,
          maturityInvCtg: true,
          maturityCount: true,
          maturityValue: true,
          hasGrouping: true,
          groupLabel: true,
          groupEnding: true,
          details: true,
        },
      },
      selectedTab: {
        periodType: true,
      },
      setDetailTitle: { $set: 'detailTitle' },
      setDetailMarketValue: { $set: 'detailMarketValue' },
      setDetailAssets: { $set: 'detailAssets' },
      showDateRange: true,
      setShowDateRange: { $set: 'showDateRange' },
      setFromDate: { $set: 'fromDate' },
      settoDate: { $set: 'toDate'},
      setSelectedTabIndex: { $set: 'selectedTabIndex'}
    },
    ui: {
      state: {
        maturities: {
          selectedKey: true,
          ascending: true,
          onOptionSelect: { $call: 'changeSort' },
          resetSort: { $call: 'resetSort' },
        },
        maturitiesAssets: {
          resetDetailSort: { $call: 'resetSort' },
        },
      },
      static: {
        maturities: {
          options: true,
        }
      },
    },
    portfolio:{
      overallMarketValue:{
        asOfDate: true,
      },
    }
  },
})(Maturities);
